import React, { Component } from 'react'
import styled from 'styled-components'

import IcIcon from './ic-search.component.svg'

class NoResultsV2 extends Component {
  render() {
    const { children, title, text } = this.props

    return (
      <Wrapper>
        <IcIcon />
        <Content>
          {title && <Title>Sem Resultados Disponíveis.</Title>}
          {text && (
            <div>
              <Text>
                Por favor, tente alterar os dados do seu tarifário de forma a
                visualizar resultados.
              </Text>
              <Text>
                Se precisar de ajuda contacte-nos através do <b>211 160 500.</b>
              </Text>
            </div>
          )}
          {children}
        </Content>
      </Wrapper>
    )
  }
}

export default NoResultsV2

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 32px;
  gap: 16px;
`

const Title = styled.h3`
  overflow: hidden;
  color: #1d1e22;
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;
  font-family: Nunito;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 133.333% */
  letter-spacing: 1px;
  margin: 0;
  text-transform: unset;
`

const Text = styled.p`
  overflow: hidden;
  color: #3e3e3e;
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  margin: 0;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  align-self: stretch;
`



// WEBPACK FOOTER //
// ./src/components/NoResultsV2/index.js